module.exports = __webpack_public_path__ + "49fa4e75d6970befda2fa7bb74b7ae2b.jpg";